<template>
    <div>
        <b-button
            :id="target_id"
            variant="link"
            size="sm"
            class="p-0 ml-1 text-secondary"
            style="font-size: 0.875rem;margin-top: -2px"
        >
            <fa icon="question-circle"></fa>
        </b-button>
        <b-popover
            :id="`${target_id}-popover`"
            :target="target_id"
            :show.sync="showPopover"
            triggers="click"
            placement="right"
            custom-class="project-input-desc-popover"
            @shown="onPopoverShown"
            @hidden="onPopoverHidden"
        >
            <template #title>
                <div class="d-flex justify-content-between align-items-center">
                    <span>{{ label }} {{ $t('설명') }}</span>
                    <b-button
                        variant="link"
                        size="sm"
                        class="p-0 text-secondary"
                        @click="closePopover"
                    >
                        <fa icon="times"></fa>
                    </b-button>
                </div>
            </template>
            <section>
                <template v-if="getDescription.type === 'object'">
                    <div v-html="getDescription.value?.[$i18n.locale]"/>
                </template>
                <template v-else>
                    {{ getDescription.value}}
                </template>
            </section>
        </b-popover>
    </div>
</template>

<script>
export default {
    name: 'ProjectInputDescriptionPopOver',
    props: {
        input_key: {
            type: [Object,null],
            default: null,
        },
        label: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            showPopover: false,
        };
    },
    computed: {
        target_id() {
            return `${this.input_key.id}-${this.input_key.key_name}-description`; 
        },
        getDescription(){
            if(!this.input_key.description) return {
                type: 'unknown',
                value: '-'
            };
            const parsed = JSON.parse(this.input_key.description);
            if(typeof parsed === 'string')  {
                return {
                    type: 'string',
                    value: parsed
                };
            }
            else if(typeof parsed === 'object') {
                return {
                    type: 'object',
                    value: parsed
                };
            }
            return {
                type: 'unknown',
                value: parsed
            };
        },
    },
    methods: {
        closePopover() {
            this.showPopover = false;
        },
        onPopoverShown() {
            // 외부 클릭 시 popover 닫기
            document.addEventListener('click', this.handleOutsideClick);
            // 스크롤 시 popover 닫기
            window.addEventListener('scroll', this.handleScroll, true);
        },
        onPopoverHidden() {
            // 이벤트 리스너 제거
            document.removeEventListener('click', this.handleOutsideClick);
            window.removeEventListener('scroll', this.handleScroll, true);
        },
        handleOutsideClick(event) {
            // popover 요소와 트리거 버튼 확인
            const popoverElement = document.getElementById(`${this.target_id}-popover`);
            const triggerElement = document.getElementById(this.target_id);
            
            if (popoverElement && triggerElement) {
                // 클릭된 요소가 popover 내부나 트리거 버튼이 아닌 경우
                if (!popoverElement.contains(event.target) && !triggerElement.contains(event.target)) {
                    this.closePopover();
                }
            }
        },
        handleScroll() {
            this.closePopover();
        }
    }
};
</script>

<style lang="scss">
.project-input-desc-popover {
    max-width: 480px !important;
    .report-examples {
        .example-case {
            
            padding: 12px;
            border-radius: 6px;

            &:last-child {
                margin-bottom: 4px;
            }
            .title-wrapper {
                display: flex;
                align-items: center;
                gap: 8px;
                h6 {
                    font-weight: 600;
                    font-size: 0.9rem;
                    margin-bottom: 0;
                }
            }

            

            .example-text {
                border: 1px solid #dee2e6;
                border-radius: 8px;
                padding: 8px 12px;
                line-height: 1.5;
                margin-bottom: 0;
                font-size: 0.95rem;
            }
        }
    }

}
</style>
